import { Simulation } from 'models/Simulation';
import axios from 'utils/axios';

class SimulationService {
    async changeSimulation(tenantId: string, userName: string, simulationId?: string | null): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/ChangeSimulazione', { tenantId, userName, simulazioneId: simulationId });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to change simulation');
        }
    }

    async upsertSimulation(tenantId: string, userId: string, userName: string, newSimulation: Simulation): Promise<string | null> {
        try {
            const res = await axios.post<string | null>('/UpsertSimulazione', {
                tenantId,
                userId,
                userName,
                simulazioneIdToCopy: newSimulation.simulationIdToCopy,
                id: newSimulation.id,
                name: newSimulation.name,
                note: newSimulation.note
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to create a new simulation');
        }
    }

    async getSimulationsItems(tenantId: string): Promise<Simulation[]> {
        try {
            const res = await axios.post<Simulation[]>('/GetSimulazioniItems', tenantId);
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch simulations items');
        }
    }

    async acceptSimulation(tenantId: string, userId: string, username: string, simulationId: string): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/SaveSimulazioneInProduction', {
                tenantId,
                userId,
                username,
                id: simulationId
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to accpet simulation');
        }
    }

    async deleteSimulation(userId: string, username: string, simulationId: string): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/InvalidateSimulazione', {
                userId,
                username,
                id: simulationId
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to delete simulation');
        }
    }
}

export default SimulationService;
